import React from 'react';

const ELD_NAMES = {
  1: 'Social & Instructional',
  2: 'Language Arts',
  3: 'Mathematics',
  4: 'Science',
  5: 'Social Studies',
};

const ELD_COLORS = {
  1: 'bg-teal-50 text-teal-700 border-teal-200',
  2: 'bg-violet-50 text-violet-700 border-violet-200',
  3: 'bg-sky-50 text-sky-700 border-sky-200',
  4: 'bg-lime-50 text-lime-700 border-lime-200',
  5: 'bg-amber-50 text-amber-700 border-amber-200',
};

const KLU_COLORS = {
  Narrate: 'bg-pink-50 text-pink-700 border-pink-200',
  Inform: 'bg-blue-50 text-blue-700 border-blue-200',
  Explain: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  Argue: 'bg-red-50 text-red-700 border-red-200',
};

export const ELDBadge = ({ standard, size = 'sm' }) => {
  if (!standard) return null;
  const num = typeof standard === 'string' ? parseInt(standard) : standard;
  const name = ELD_NAMES[num];
  if (!name) return null;
  const color = ELD_COLORS[num] || 'bg-gray-50 text-gray-700 border-gray-200';
  const sizeClass = size === 'xs' ? 'text-[10px] px-1.5 py-0' : 'text-xs px-2 py-0.5';

  return (
    <span
      className={`inline-flex items-center border font-medium ${color} ${sizeClass}`}
      title={`WIDA ELD Standard ${num}: ${name}`}
      data-testid={`eld-badge-${num}`}
    >
      ELD {num}: {name}
    </span>
  );
};

export const KLUBadge = ({ klu, size = 'sm' }) => {
  if (!klu) return null;
  const color = KLU_COLORS[klu] || 'bg-gray-50 text-gray-700 border-gray-200';
  const sizeClass = size === 'xs' ? 'text-[10px] px-1.5 py-0' : 'text-xs px-2 py-0.5';

  return (
    <span
      className={`inline-flex items-center border font-medium ${color} ${sizeClass}`}
      title={`Key Language Use: ${klu}`}
      data-testid={`klu-badge-${klu}`}
    >
      {klu}
    </span>
  );
};

export const StandardsBadges = ({ eldStandard, klu, size = 'sm' }) => {
  if (!eldStandard && !klu) return null;
  return (
    <span className="inline-flex items-center gap-1.5 flex-wrap" data-testid="standards-badges">
      <ELDBadge standard={eldStandard} size={size} />
      <KLUBadge klu={klu} size={size} />
    </span>
  );
};
